import React, { useEffect } from 'react'
import { If, Then } from 'react-if'

import { Footer, Header, SubHeaderMenu } from 'components'
import useApp from 'hooks/useApp'
import styled from 'styled-components'
interface IContainer {
  width?: string
}
const Container = styled.div<IContainer>`
  width: ${({ width }) => width};
  margin-top: 4rem;
  margin-bottom: 2rem;
  margin-left: auto;
`
export interface ITemplatePage {
  hideMenus: boolean
  page: any
  title: string
}
const TemplatePage: React.FC<ITemplatePage> = ({ hideMenus, page, title }) => {
  const { titlePage } = useApp()

  return (
    <Container width={hideMenus ? '100%' : 'calc(100% - 95px)'}>
      {!hideMenus && (
        <>
          <Header />
          <SubHeaderMenu titlePage={titlePage || title} />
        </>
      )}
      <If condition={page}>
        <Then>{page}</Then>
      </If>
      <Footer />
    </Container>
  )
}

export default TemplatePage
